import { AdDisplayMode } from '@shared/enums/AdDisplayMode';

const DEFAULT_INTERVAL_SECONDS = 5 * 60;
export const DEFAULT_DURATION_SECONDS = 10;

// Normalizes fixed and custom interval modes so renderers do not duplicate timing math.
export function getIntervalDisplayTiming(displayMode, displayIntervalSeconds, displayDurationSeconds) {
	if (displayMode === AdDisplayMode._10S_EACH_5M) {
		return {
			intervalSeconds: DEFAULT_INTERVAL_SECONDS,
			durationSeconds: DEFAULT_DURATION_SECONDS,
		};
	}

	const customIntervalSeconds = getPositiveSeconds(displayIntervalSeconds);
	const customDurationSeconds = getPositiveSeconds(displayDurationSeconds);
	if (displayMode === AdDisplayMode._CUSTOM && customIntervalSeconds && customDurationSeconds) {
		return {
			intervalSeconds: customIntervalSeconds,
			durationSeconds: customDurationSeconds,
		};
	}

	return null;
}

export function isIntervalDisplayMode(displayMode) {
	return [AdDisplayMode._10S_EACH_5M, AdDisplayMode._CUSTOM].includes(displayMode);
}

export function isIntervalDisplayVisible(displayMode, position, displayIntervalSeconds, displayDurationSeconds) {
	const timing = getIntervalDisplayTiming(displayMode, displayIntervalSeconds, displayDurationSeconds);

	if (!timing) {
		return false;
	}

	return (position || 0) % timing.intervalSeconds < timing.durationSeconds;
}

export function getIntervalDisplaySlotIndex(displayMode, position, displayIntervalSeconds, displayDurationSeconds) {
	const timing = getIntervalDisplayTiming(displayMode, displayIntervalSeconds, displayDurationSeconds);

	if (!timing) {
		return 0;
	}

	return Math.floor((position || 0) / timing.intervalSeconds);
}

export function isOnceDisplayMode(displayMode) {
	return displayMode === AdDisplayMode._10S_ONCE;
}

function getPositiveSeconds(value) {
	const seconds = Number(value);
	return Number.isFinite(seconds) && seconds > 0 ? seconds : null;
}
